(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds24-header-new"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const header = event.target.closest('.ds24-new-header');
    const activeSummary = event.target.closest('.ds24-new-header__nav-item > details > summary');

    document.querySelectorAll('.ds24-new-header__nav-item > details[open]').forEach((details) => {
      if (!activeSummary || details !== activeSummary.parentElement) {
        details.removeAttribute('open');
      }
    });

    if (!header) {
      document.querySelectorAll('.ds24-new-mobile-menu[open]').forEach((details) => details.removeAttribute('open'));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('.ds24-new-header details[open]').forEach((details) => details.removeAttribute('open'));
  });

  const bindCartCounters = () => {
    document.querySelectorAll('.ds24-new-cart').forEach((link) => {
      if (link.dataset.counterBound) return;
      const counter = link.querySelector('cart-count');
      if (!counter) return;
      link.dataset.counterBound = 'true';
      const updateLabel = () => {
        const count = Number.parseInt(counter.textContent, 10);
        if (!Number.isFinite(count)) return;
        link.setAttribute('aria-label', link.dataset.cartLabel.replace('__COUNT__', String(count)));
      };
      new MutationObserver(updateLabel).observe(counter, { childList: true, characterData: true, subtree: true });
      updateLabel();
    });
  };
  bindCartCounters();
  document.addEventListener('shopify:section:load', bindCartCounters);


  } catch(e) { console.error(e); }
})();
})();
